if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.nativeProductForm = this.querySelector('form[data-type="add-to-cart-form"]');
        if (!this.nativeProductForm) return;
        this.variantIdInput.disabled = !this.variantIdInput.value;
        this.nativeProductForm.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const productInfo = this.closest('product-info');
        const commerceState = productInfo?.dataset.scoreggiaCommerceState;
        const guardedProductPage = productInfo?.hasAttribute('data-scoreggia-commerce-state');
        const variantId = this.variantIdInput?.value || '';
        const exactVariantId = productInfo?.dataset.scoreggiaExactVariantId || '';
        const purchaseAction = this.querySelector('[data-scoreggia-purchase-action]');
        const currentProductForms = productInfo?.querySelectorAll('product-form > form[data-type="add-to-cart-form"]');
        const currentVariantInputs = productInfo?.querySelectorAll(
          'product-form > form[data-type="add-to-cart-form"] input[name="id"]'
        );
        if (
          (guardedProductPage && commerceState !== 'available') ||
          (guardedProductPage &&
            (!this.isConnected ||
              !productInfo.isConnected ||
              !this.nativeProductForm.isConnected ||
              !this.submitButton.isConnected ||
              !purchaseAction?.isConnected ||
              purchaseAction.hidden ||
              purchaseAction.getAttribute('aria-hidden') === 'true' ||
              this.submitButton.hidden ||
              this.submitButton.disabled ||
              !purchaseAction.contains(this.submitButton))) ||
          this.variantIdInput.disabled ||
          !/^\d+$/.test(variantId) ||
          (guardedProductPage && variantId !== exactVariantId) ||
          (guardedProductPage && currentProductForms?.length !== 1) ||
          (guardedProductPage && currentVariantInputs?.length !== 1) ||
          !this.quantityIsValid()
        ) {
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.nativeProductForm);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const submittedVariantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(submittedVariantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: submittedVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: submittedVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            const currentProductInfo = this.closest('product-info');
            const currentPurchaseAction = this.querySelector('[data-scoreggia-purchase-action]');
            const guardedProductPage = currentProductInfo?.hasAttribute('data-scoreggia-commerce-state');
            const guardedActionAvailable =
              !guardedProductPage ||
              (currentProductInfo.dataset.scoreggiaCommerceState === 'available' &&
                currentPurchaseAction?.isConnected &&
                !currentPurchaseAction.hidden &&
                currentPurchaseAction.getAttribute('aria-hidden') !== 'true' &&
                !this.submitButton.hidden &&
                !this.submitButton.disabled);
            if (!this.error && guardedActionAvailable) this.submitButton.removeAttribute('aria-disabled');
            else this.submitButton.setAttribute('aria-disabled', 'true');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const productInfo = this.closest('product-info');
        const guardedPurchaseAction = productInfo?.hasAttribute('data-scoreggia-commerce-state');
        const purchaseAction = this.querySelector('[data-scoreggia-purchase-action]');
        if (
          guardedPurchaseAction &&
          (productInfo.dataset.scoreggiaCommerceState !== 'available' ||
            !purchaseAction?.isConnected ||
            purchaseAction?.hidden ||
            purchaseAction?.getAttribute('aria-hidden') === 'true')
        ) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          return;
        }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      quantityIsValid() {
        const input = this.nativeProductForm?.querySelector('[name="quantity"]');
        if (!input) return true;
        const value = Number(input.value);
        const min = input.min === '' ? 1 : Number(input.min);
        const max = input.max === '' ? Infinity : Number(input.max);
        const step = input.step === '' || input.step === 'any' ? 1 : Number(input.step);
        return (
          Number.isFinite(value) &&
          Number.isFinite(min) &&
          Number.isFinite(step) &&
          step > 0 &&
          value >= min &&
          value <= max &&
          Math.abs((value - min) / step - Math.round((value - min) / step)) < Number.EPSILON * 10
        );
      }

      get variantIdInput() {
        return this.nativeProductForm?.querySelector('[name=id]');
      }
    }
  );
}
